import { render, staticRenderFns } from "./videoIframe.vue?vue&type=template&id=ada7ff06&"
import script from "./videoIframe.vue?vue&type=script&lang=js&"
export * from "./videoIframe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ada7ff06')) {
      api.createRecord('ada7ff06', component.options)
    } else {
      api.reload('ada7ff06', component.options)
    }
    module.hot.accept("./videoIframe.vue?vue&type=template&id=ada7ff06&", function () {
      api.rerender('ada7ff06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UsFQbjA80HTi/JS/videoIframe.vue"
export default component.exports